import request from "../../Request";
import {rThen} from "../../requestThen";

export let deleteAvatar = async (userId) => {

    return request.delete(`/api/base_user/delete_avatar/${userId}`,).then(r => {
        return rThen(r);
    })
}